import { Injectable, Injector } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpXsrfTokenExtractor
} from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';

@Injectable()

/*
 * Since Angular is handling the XSRF Token incorrect in 5.X
 * this is a custom http interceptor to add an XSRF Token
 */
export class AppHttpInterceptor {
  constructor(private tokenExtractor: HttpXsrfTokenExtractor) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let requestToForward = req;
    const token = this.tokenExtractor.getToken() as string;

    requestToForward = req.clone({
      withCredentials: true
    });

    // Clone the request to add the new header for post requests and if token exists.
    if (token !== null) {
      requestToForward = req.clone({
        headers: req.headers.set('X-Csrf-Token', token),
        withCredentials: true
      });
    }

    // send the newly created request
    return next.handle(requestToForward).catch((error, caught) => {
      // return the error to the method that called it
      return Observable.throw(error);
    }) as any;
  }
}
